import { Close as CloseIcon } from "@mui/icons-material";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  IconButton,
} from "@mui/material";
import React from "react";
import { useCelleraTheme } from "theme/useCelleraTheme";

interface ConnectWalletDialogProps {
  open: boolean;
  onClose: () => void;
  isPracticeOwner: boolean;
  onConnectWallet?: () => void;
}

export const ConnectWalletDialog: React.FC<ConnectWalletDialogProps> = ({
  open,
  onClose,
  isPracticeOwner,
  onConnectWallet,
}) => {
  const { colors, getColor } = useCelleraTheme();

  const handleConnectWallet = () => {
    if (onConnectWallet) {
      onConnectWallet();
    }
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      slotProps={{
        paper: {
          sx: {
            borderRadius: 2,
          },
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          pb: 2,
        }}
      >
        <Typography
          variant="h6"
          sx={{
            fontWeight: 600,
            color: colors.text.primary,
          }}
        >
          Connect Wallet To Proceed
        </Typography>
        <IconButton
          onClick={onClose}
          size="small"
          sx={{
            color: colors.text.primary,
            "&:hover": {
              backgroundColor: colors.background.secondary,
            },
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ pb: 3 }}>
        <Typography
          variant="body1"
          sx={{
            color: colors.text.primary,
            lineHeight: 1.5,
          }}
        >
          {isPracticeOwner
            ? "You need to connect your wallet to proceed. Do you want to go to Practice Configuration to connect your wallet?"
            : "You need to connect your wallet to proceed. Please contact your practice admin to update"}
        </Typography>
      </DialogContent>
      <DialogActions
        sx={{
          px: 3,
          pb: 3,
          gap: 2,
          justifyContent: isPracticeOwner ? "flex-end" : "flex-end",
        }}
      >
        {isPracticeOwner ? (
          <>
            <Button
              variant="outlined"
              onClick={onClose}
              sx={{
                borderColor: colors.border.light,
                color: colors.text.primary,
                textTransform: "none",
                px: 3,
                "&:hover": {
                  borderColor: colors.border.light,
                  backgroundColor: colors.background.secondary,
                },
              }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={handleConnectWallet}
              sx={{
                backgroundColor: getColor("primary.main"),
                color: "white",
                textTransform: "none",
                px: 3,
                "&:hover": {
                  backgroundColor: getColor("primary.dark"),
                },
              }}
            >
              Connect Wallet
            </Button>
          </>
        ) : (
          <Button
            variant="contained"
            onClick={onClose}
            sx={{
              backgroundColor: getColor("primary.main"),
              color: "white",
              textTransform: "none",
              px: 3,
              borderRadius: 1,
              "&:hover": {
                backgroundColor: getColor("primary.dark"),
              },
            }}
          >
            Got it
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};
